/**
 * Коды прав хаба (IC-2972). Дублируют серверный enum
 * `BeOpenHub.Internal.Permissions.HubPermissionCode` — держать синхронно с ним.
 *
 * Исторически коды объявлялись инлайн в каждом компоненте; гранулярные права
 * меню/стоплистов (фаза D) используются во многих местах, поэтому вынесены сюда
 * как единый источник правды. Значения существующих прав менять нельзя — они
 * персистентны (БД role_permissions, JWT permission_code).
 */
export const PermissionCode = {
  ProductView: 1000031,
  ProductEdit: 1000032,
  ProductDelete: 1000033,

  MenuView: 1000041,
  MenuEdit: 1000042,
  MenuDelete: 1000043,

  /** Ручная выгрузка меню и стоплистов. */
  MenuUpload: 1000044,

  /** Просмотр истории выгрузок меню и стоплистов. */
  MenuUploadHistoryView: 1000045,

  /** Настройка расписания автоматических выгрузок меню и стоплистов. */
  MenuUploadScheduleEdit: 1000046,

  /** Ручное изменение публикации меню (кнопка published и обратно). */
  MenuPublicationToggle: 1000047,

  /** Скачивание файлов результата конвертации меню из истории. */
  MenuConversionFileDownload: 1000048,

  SpecialInstructionView: 1000081,
  SpecialInstructionEdit: 1000082,
} as const;
